import React, { useState, useEffect } from 'react';
import './InitiativeApproval.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Col, Row } from 'react-bootstrap';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import StartOutlinedIcon from '@mui/icons-material/StartOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import NoPhotographyOutlinedIcon from '@mui/icons-material/NoPhotographyOutlined';
import { TextField, Button } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const InitiativeApproval = () => {
  const [comments, setComments] = useState('');
  const [approvalStatus, setApprovalStatus] = useState('');
  const [initiativeDetails, setInitiativeDetails] = useState(null);
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  //Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
  useEffect(() => {
    const validateTokenAndFetchDetails = async () => {
      if (!token) {
        toast.error("Invalid or missing query parameters.");
        return;
      }

      try {
        const detailsRes = await fetch(`${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/GetInitiativeDetails?token=${token}`);
        const details = await detailsRes.json();
        var resDetals = details;
        //setInitiativeDetails(details?.data?.[0]);
        setInitiativeDetails(details?.data?.InitiativeDetailsEntity?.[0]);

        const validationRes = await fetch(`${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/approve-reject?token=${token}`, { method: "POST" });
        const result = await validationRes.json();

        if (result.message === "LinkExpired") {
          toast.error("This link has been expired.");
            setTimeout(() => window.close(), 1000);
          return;
        } else if (result.message === "InValidLink") {
          toast.error("The link is not valid.");
           setTimeout(() => window.close(), 1000);
          return;
        }

      } catch (error) {
        toast.error("Something went wrong while loading the initiative.");
      }
    };

    validateTokenAndFetchDetails();
  }, [searchParams]);

  const handleSubmit = async (actionType) => {
    if (!comments.trim()) {
      toast.error('Comment should not be left blank.');
      return;
    }

    let decideaID, decuserID;

    try {
      const getIdeaUserRes = await fetch(
        `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/GetIdeaUser?token=${token}`,
        { method: 'GET' }
      );

      const getValidateStages = await fetch(
        `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/GetValidateStages?token=${token}`,
        { method: 'GET' }
      );

      const stagevalidateresult = await getValidateStages.json();
      const decryptData = await getIdeaUserRes.json();
      decideaID = decryptData.initiativeid;
      decuserID = decryptData.empid;
      //commented and Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
      // if (stagevalidateresult.data?.[0]?.result == 1) {
      //   const validateApproveRes = await fetch(
      //     `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/ValidateApprove?IdeaID=${decideaID}&UserID=${decuserID}`,
      //     { method: 'GET' }
      //   );
      //   const validateApproveResult = await validateApproveRes.json();

      //   if (validateApproveResult.data?.[0]?.result !== 'Success') {
      //     toast.error(validateApproveResult.data?.[0]?.result);
      //     return;
      //   }

      // } else {
      //   toast.error(stagevalidateresult.data?.[0]?.result || "Stage validation failed.");
      //   return;
      // }
      if (stagevalidateresult.data?.[0]?.result == 1) {
        // Decide which validation endpoint to call
        const validationEndpoint =
          actionType === 'approve'
            ? 'ValidateApprove'
            : 'ValidateReject';

        const validationRes = await fetch(
          `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/${validationEndpoint}?IdeaID=${decideaID}&UserID=${decuserID}`,
          { method: 'GET' }
        );

        const validationResult = await validationRes.json();

        if (validationResult.data?.[0]?.result !== 'Success') {
          toast.error(validationResult.data?.[0]?.result);
          return;
        }
      } else {
        toast.error(stagevalidateresult.data?.[0]?.result || "Stage validation failed.");
        return;
      }
      // End of Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval      
      const actionParam = actionType === 'approve' ? 'Approve' : 'Reject';

      const wfRes = await fetch(
        `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeWorflowActions/WorkflowActions?IdeaID=${decideaID}&UserID=${decuserID}&Action=${actionParam}&Comments=${encodeURIComponent(comments)}`,
        { method: 'PUT' }
      );

      const wfText = await wfRes.json();

      if (wfText?.message === 'Initiative Workflow Approved') {
        toast.success('Initiative approved successfully!');
        setApprovalStatus('success');
        setTimeout(() => window.close(), 1000);
      } else if (wfText?.message === 'Initiative Workflow Rejected') {
        //toast.info('Initiative pushed back.');
        toast.info('Initiative pushback successfully!');
        setApprovalStatus('pushback');
        setTimeout(() => window.close(), 1000);
      } else {
        toast.error(`${wfText?.message || 'Approval failed.'}`);
        setApprovalStatus('error');
      }

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong during approval process.");
      setApprovalStatus('error');
    }

    setComments('');
  };

  const handleCancel = () => {
    setComments('');
    setApprovalStatus('');
  };
  //End of Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
  if (!initiativeDetails) return <div className="mailcontainer">Loading initiative details...</div>;

  return (
    <div className="mailcontainer">
      <ToastContainer />
      <h5 className="header">Initiative Details</h5>

      <div className="field">
        <label>Hi, <span>{initiativeDetails?.employeeName || 'User'}</span></label>
        {/* commented by Aditya J. on 07-07-2025 for Initiative Email Base Approval */}
        {/* <span>Approval is required for the following Nature Of Initiative</span> */}
        <span>Approval is required for the following Initiative</span>
        {/* end of commented by Aditya J. on 07-07-2025 for Initiative Email Base Approval */}
      </div>

      <div className="field mt-3 bg_Top">
        <Row>
          <Col md={6}>
            <Row className="custom-gutter1">
              <Col md={6}><label>Initiative Title : </label></Col>
              <Col md={6}><span title={initiativeDetails?.title?.length > 15 ? initiativeDetails?.title : ''}>{initiativeDetails?.initiativeImage ? (
                <img
                  src={`${initiativeDetails?.initiativeImage}`}
                  alt="Initiative"
                  style={{ width: '20px', objectFit: 'contain' }}
                />
              ) : (
                <NoPhotographyOutlinedIcon style={{ fontSize: "20px", color: "#888" }} />
              )} {initiativeDetails?.title?.length > 15
                ? `${initiativeDetails?.title.substring(0, 15)}...`
                : initiativeDetails?.title || 'NA'}</span></Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={6}><label>Initiative Code : </label></Col>
              <Col md={6}><span>{initiativeDetails?.initiativeCode || 'NA'}</span></Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className="custom-gutter1">
              <Col md={6}><label>Nature Of Initiative :</label></Col>
              <Col md={6}><span title={initiativeDetails?.natureofDemand?.length > 20 ? initiativeDetails?.natureofDemand : ''}
              >{initiativeDetails?.natureofDemand?.length > 15
                ? `${initiativeDetails?.natureofDemand.substring(0, 20)}...`
                : initiativeDetails?.natureofDemand || 'NA'}</span></Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={6}><label>Current Stage : </label></Col>
              <Col md={6}><span>{initiativeDetails?.currentStageName || 'NA'}</span></Col>
            </Row>
          </Col> 
          <Col md={6}>
            <Row className="custom-gutter1">
              <Col md={6}><label>Initiative From Date : </label></Col>
              <Col md={6}><span><CalendarMonthOutlinedIcon style={{ fontSize: "12px" }} /> {initiativeDetails?.expectedStartDate || 'NA'}</span></Col>
            </Row>
            <Row className="custom-gutter1">
              <Col md={6}><label>Business Group : </label></Col>
              <Col md={6}><span>{initiativeDetails?.businessGroup || 'NA'}</span></Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={6}><label>Initiative To Date :  </label></Col>
              <Col md={6}><span><CalendarMonthOutlinedIcon style={{ fontSize: "12px" }} /> {initiativeDetails?.expectedEndDate || 'NA'}</span></Col>
            </Row>
            <Row>
              <Col md={6}><label>Organization Unit : </label></Col>
              <Col md={6}><span>{initiativeDetails?.organizationUnit || 'NA'}</span></Col>
            </Row>
            {/* Added by Aditya J. on 09-07-2025 for Initiative Email Base Approval */}

            {/* End of Added by Aditya J. on 09-07-2025 for Initiative Email Base Approval */}
          </Col>
          {/* commented and Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval */}
          {/* <Col md={12} className='d-flex justify-content-center gap-3 mt-3' style={{ backgroundColor: '#e8ffec' }}>
            <span className='stage-label1'>{initiativeDetails?.previousStageName || 'NA'}</span>
            <StartOutlinedIcon style={{ color: '#ddd' }} />
            <span className='stage-label2'>{initiativeDetails?.currentStageName || 'NA'}</span>
            <StartOutlinedIcon style={{ color: '#ddd' }} />
            <span className='stage-label3'>{initiativeDetails?.futureStageName || 'NA'}</span>
          </Col> */}
          <Col md={12} className='d-flex justify-content-center gap-3 mt-3' style={{ backgroundColor: '#e8ffec' }}>
            {initiativeDetails?.previousStageName && (
              <>
                <span className='stage-label1'>{initiativeDetails.previousStageName}</span>
                <StartOutlinedIcon style={{ color: '#ddd' }} />
              </>
            )}

            {initiativeDetails?.currentStageName && (
              <>
                <span className='stage-label2'>{initiativeDetails.currentStageName}</span>
                {initiativeDetails?.futureStageName && <StartOutlinedIcon style={{ color: '#ddd' }} />}
              </>
            )}

            {initiativeDetails?.futureStageName && (
              <span className='stage-label3'>{initiativeDetails.futureStageName}</span>
            )}
          </Col>
          {/* end of commented and Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval */}
        </Row>
      </div>

      <div className="mt-4" style={{ fontWeight: 'bold' }}>
        <span>( Approve / Push Back ) <label> Comment <span style={{ color: 'red' }}>*</span></label></span>
      </div>

      <div className="mt-3">
        <TextField
          fullWidth
          //placeholder='Example: "Please approve this" or "Push back for revision"'
          placeholder='Approve or Pushback the Initiative'
          multiline
          rows={2}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </div>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <Button variant="contained" onClick={() => handleSubmit('approve')}>Approve</Button>
        <Button variant="contained" onClick={() => handleSubmit('pushback')}>Push Back</Button>
      </div>

      <div className='Note'>
        <span style={{ color: 'red' }}>Note :
          <span> Please fill in all mandatory fields so we can proceed further.</span><br />
          <span style={{ paddingLeft: "32px" }}>Please upload the document to approve the Initiative</span>
        </span>
      </div>

      {approvalStatus === 'success' && (
        <div className="dialog-footer mt-4">
          <span className="footer-text">
            <CelebrationOutlinedIcon style={{ marginRight: 8, color: "#eeb237", fontSize: "25px" }} />
            Thank you for your approval.
          </span>
        </div>
      )}
      {approvalStatus === 'error' && (
        <div className="dialog-footer mt-4">
          <span className="footer-text">
            <SentimentDissatisfiedOutlinedIcon style={{ marginRight: 8, color: "#fef100", fontSize: "25px" }} />
            Sorry, this is not able to approve. Please contact Admin.
          </span>
        </div>
      )}
      {approvalStatus === 'pushback' && (
        <div className="dialog-footer mt-4">
          <span className="footer-text">
            <PauseCircleOutlineOutlinedIcon style={{ marginRight: 8, color: "#f39c12", fontSize: "25px" }} />
            The initiative has been pushed back for revision.
          </span>
        </div>
      )}
    </div>
  );
};

export default InitiativeApproval;
